var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticStyle:{"width":"25px"},attrs:{"src":`/flag/${_vm.code}.png`,"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }